import {
  Autocomplete,
  CircularProgress,
  FormControl,
  FormGroup,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { PolarisObject } from "../../../../app/backendTypes";

export default function PolarisGroupPicker(props: {
  groups: PolarisObject[];
  loading: boolean;
  error: string | undefined;
  onChange: (val: PolarisObject | null) => void;
  initialValue: PolarisObject | null;
}) {
  const { groups, loading, error, onChange, initialValue } = props;

  const theme = useTheme();

  return (
    <FormControl fullWidth>
      <FormGroup>
        <Autocomplete
          value={initialValue}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          size="small"
          disabled={loading || Boolean(error)}
          options={groups}
          getOptionLabel={(object) => `${object.attributes.groupname}`}
          renderOption={(props, object) => (
            <Typography {...props}>{object.attributes.groupname}</Typography>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              placeholder={
                loading ? "Loading..." : error ? "Error" : "Pick a group"
              }
              error={Boolean(error)}
              sx={{
                input: {
                  "&::placeholder": {
                    color: Boolean(error)
                      ? theme.palette.error.main
                      : "text.secondary",
                    opacity: 1,
                  },
                },
              }}
            />
          )}
          onChange={(_, value) => onChange(value)}
        />
      </FormGroup>
    </FormControl>
  );
}
